import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-modal-footer');
export const ModalFooter = observer(({ children, layout }) => {
    if (!children)
        return null;
    return (_jsx("footer", { className: b.block({ layout }), children: _jsx("div", { className: b.element('content'), children: children }) }));
});
ModalFooter.displayName = 'ModalFooter';
//# sourceMappingURL=footer.js.map